export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-gradient-to-br from-primary-900 to-primary-950 rounded-2xl overflow-hidden">
          <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50">
              移动观影
            </h2>
            <p className="mt-4 text-sm text-white/70 leading-relaxed max-w-md mx-auto lg:mx-0">
              爱丫爱丫影院移动版已全面适配手机与平板设备。无论您在通勤路上还是旅行途中，
              打开手机浏览器即可享受与桌面端一致的高清流畅观影体验，片源实时同步，续播进度云端保存。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 text-xs text-white/65">
                <span className="w-5 h-5 flex items-center justify-center rounded bg-accent-500/30">
                  <i className="ri-smartphone-line text-accent-400 text-xs"></i>
                </span>
                <span className="whitespace-nowrap">手机适配</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-white/65">
                <span className="w-5 h-5 flex items-center justify-center rounded bg-accent-500/30">
                  <i className="ri-tablet-line text-accent-400 text-xs"></i>
                </span>
                <span className="whitespace-nowrap">平板支持</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-white/65">
                <span className="w-5 h-5 flex items-center justify-center rounded bg-accent-500/30">
                  <i className="ri-cloud-line text-accent-400 text-xs"></i>
                </span>
                <span className="whitespace-nowrap">云端续播</span>
              </div>
            </div>

            <div className="mt-7">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-qr-scan-line"></i>
                </span>
                扫码体验移动版
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-full lg:w-auto px-8 lg:px-0 lg:pr-12 pb-8 lg:pb-0">
            <div className="relative mx-auto w-[180px] h-[360px] bg-background-50 rounded-3xl border-4 border-background-200 overflow-hidden">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-5 bg-background-950 rounded-b-xl"></div>
              <div className="pt-6 px-3 space-y-2.5">
                {[1, 2, 3, 4, 5].map((i) => (
                  <div key={i} className="flex items-center gap-2 p-2 bg-background-100 rounded-lg">
                    <div className={`w-10 h-10 rounded-md flex-shrink-0 ${
                      i % 3 === 0 ? 'bg-accent-200' : i % 3 === 1 ? 'bg-primary-200' : 'bg-secondary-200'
                    }`}></div>
                    <div className="flex-1 space-y-1">
                      <div className="h-2 bg-background-300 rounded w-3/4"></div>
                      <div className="h-1.5 bg-background-200 rounded w-1/2"></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}